module.exports = __webpack_public_path__ + "static/media/background-2-480w.9656139e.webp";